import { render, staticRenderFns } from "./issueFlowEdit.vue?vue&type=template&id=6be1fc46&scoped=true&"
import script from "./issueFlowEdit.vue?vue&type=script&lang=js&"
export * from "./issueFlowEdit.vue?vue&type=script&lang=js&"
import style0 from "./issueFlowEdit.vue?vue&type=style&index=0&id=6be1fc46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be1fc46",
  null
  
)

export default component.exports